import React, { useState } from "react";
import back from "../image/back.png";

const GSTAudit = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="bg-white rounded-lg">
      {/* Background Section */}
      <div
        className="bg-cover bg-center h-60 flex flex-col justify-center items-center text-center"
        style={{
          backgroundImage: `url(${back})`,
        }}
      >
        <h1 className="text-3xl font-bold text-blue-700">GST Audit</h1>
        <p className="mt-2 max-w-3xl text-black font-semibold text-lg lg:text-2xl">
          Accurate and Efficient GST Audit Services with Sanjay K Nathani & Co.
        </p>
      </div>

      {/* Description Section */}
      <div className="mt-6 px-6 lg:px-20">
        <p className="text-gray-700 leading-relaxed mb-6">
          The implementation of the Goods and Services Tax (GST) has necessitated significant operational adjustments for businesses in India. As GST compliance is now mandatory, GST audits are vital for maintaining adherence to regulations. Sanjay K Nathani & Co. provides comprehensive GST audit services to assist businesses in achieving compliance and mitigating the risk of penalties.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6">
          Our team of expert GST auditors has extensive experience in conducting GST audits for businesses across various sectors. Our GST audit services include:
        </p>
        <ol className="list-disc list-inside space-y-2 text-gray-700">
          <li>Comprehensive review and analysis of GST returns and records</li>
          <li>Identification of GST liabilities and obligations</li>
          <li>Preparation and submission of GST audit reports as required by the GST Act</li>
          <li>Representation before the GST Department in case of any disputes or inquiries</li>
          <li>Recommendations on GST planning and optimization strategies</li>
        </ol>
        <br></br>
        <p>Utilizing the latest technology and software, our GST audit services are accurate, efficient, and hassle-free. Our expert team delivers customized solutions to meet your specific business needs and GST compliance requirements.</p>
      </div>

      {/* FAQ Section */}
      <h2 className="text-xl font-bold text-gray-800 mt-8 mb-4 text-center">When to conduct GST Audit mandatorily</h2>
    

      {/* Collapsible Sections */}
      <div className="space-y-4 px-6 lg:px-20">
        {/* Section 1 */}
        <div className={`border rounded-lg ${openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"}`}>
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. GSTR-9 (Annual Return)
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
            <div className="px-4 py-3 bg-white text-gray-700">
             <ul>
              <li className="font-bold">Turnover Limit:</li>
              <li>o	Mandatory: More than Rs. 2 Crore</li>
              <li>o	Optional: Up to Rs. 2 Crore</li>
             </ul>
            </div>
          )}
        </div>

        {/* Section 2 */}
        <div className={`border rounded-lg ${openSection === 2 ? "bg-blue-100" : "bg-[#005A8C]"}`}>
          <button
            onClick={() => toggleSection(2)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            2. GSTR-9C (Reconciliation Statement)
            <span>{openSection === 2 ? "-" : "+"}</span>
          </button>
          {openSection === 2 && (
            <div className="px-4 py-3 bg-white text-gray-700">
             <ul>
              <li>•	Turnover Limit: More than Rs. 5 Crore</li>
             </ul>
            </div>
          )}
        </div>
      </div>

      {/* Contact Section */}
      <div className="mt-8 bg-gray-50 p-6 rounded-md shadow-sm px-6 lg:px-20">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
        <p className="text-gray-600 mb-6">
          If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Make Appointment Button */}
          <button onClick={handleAppointmentClick} className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200">
            Make Appointment
          </button>

          {/* Contact Us Button */}
          <button className="px-6 py-2 bg-[#005A8C] text-white rounded hover:bg-blue-600 transition duration-200">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default GSTAudit;
